import {isIE, getLang, getWstaticUrl, getParameterByName} from './checkIe';
import {setCookie, getCookie} from './Utils';
import { namespace } from '@ncui-util-common/util';

namespace('ncui.util.notSupportedIe.checkIe');
window.ncui.util.notSupportedIe.checkIe = checkIe;

function checkIe(){
	let wstaticUrl = getWstaticUrl();
	let lang = getLang();

	if(isIE()){
		// 파라미터 여부에 따라 쿠키 세팅

		console.log(getParameterByName('visitedIeNotice') == 'true');
		console.log(!getCookie('visitedIeNotice') == 'true');

		if(getParameterByName('visitedIeNotice1') == 'true'){
			setCookie('visitedIeNotice1', 'true', 0, '.plaync.com'); // 쿠키 사용
			setCookie('visitedIeNotice1', 'true', 0, '.ncsoft.com'); // 쿠키 사용
		}
		// 쿠키 check 리다리렉트 할지 안할지
		else if (getCookie('visitedIeNotice1') !== 'true'){
			location.href=`${wstaticUrl}/support/not-supported-ie/html/index.html?lang=${lang}`;
		}
	}
}






